<template>
  <div
    class="sample-details-card sample-alerts is-clickable"
    role="button"
    tabindex="0"
    @click="navigateToSampleType"
    @keydown.enter.prevent="navigateToSampleType"
    @keydown.space.prevent="navigateToSampleType"
  >
    <div class="icon-alert">
      <img :src="inAlertSvgIcon" alt="alert icon" />
    </div>
    <div class="sample-alert-content">
      <h4>{{ getSampleValue }}</h4>
      <p>
        {{ $t('lastSamples.inAlert') }}
      </p>
    </div>
    <span class="sample-card-arrow f7-icons" aria-hidden="true">
      chevron_right
    </span>
  </div>
</template>

<script>
import inAlertSvgIcon from '@/static/icons/en_alerta.svg';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  name: 'AlertsCard',
  props: {
    sampleType: { type: Object, required: true },
    firstSampleTypeKey: { type: String, required: true },
  },
  data() {
    return {
      sampleTypesRouteMap: {
        Agronomía: 'AgronomySamplesPage',
        Alimentaria: 'FoodSamplesPage',
        'Medio Ambiente': 'EnvironmentSamplesPage',
        Minería: 'MiningSamplesPage',
        'Salud y Seguridad': 'HealthAndSecuritySamplesPage',
      },
    };
  },
  computed: {
    inAlertSvgIcon: () => inAlertSvgIcon,
    getSampleValue() {
      return this.firstSampleTypeKey
        ? this.sampleType[this.firstSampleTypeKey]?.in_alert || 0
        : 0;
    },
  },
  methods: {
    navigateToSampleType() {
      try {
        this.$f7router.navigate({
          name:
            this.sampleTypesRouteMap[this.firstSampleTypeKey] ??
            'DashboardHome',
          query: { dashboardAlert: 'true' },
        });
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      }
    },
  },
};
</script>

<style lang="scss">
.generic-sample-card {
  .sample-details-card.sample-alerts {
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 6px;
      background: rgba(168, 13, 11, 0.52);
    }

    .icon-alert {
      width: 34px;
      height: 34px;
      flex-shrink: 0;
      background: var(--Error-30, #f7bbba);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 23px;
        height: 23px;
        flex-shrink: 0;
        padding-bottom: 2px;
      }
    }

    .sample-alert-content {
      display: flex;
      flex: 1;
      min-width: 0;
      align-items: center;
      gap: 8px;
      flex-direction: row;
      justify-content: flex-start;

      h4 {
        color: var(--Error-70, #a80d0b);
        font-size: 21px;
        font-style: normal;
        font-weight: 700;
        line-height: 1;
        padding-bottom: 2px;
        letter-spacing: -0.02em;
        margin: 0;
      }

      p {
        color: var(--Neutral-80, #26252b);
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 1.5;
        text-decoration: none;
        margin: 0;
        white-space: nowrap;
      }
    }
  }
}
</style>
